import React from 'react'
import SvgIcon from '../../components/SvgIcon'
import { observer } from 'mobx-react'
import store from '../../store'

interface IUploadHeaderProps {
    onLogout: () => any
}

@observer
class UploadHeader extends React.Component<IUploadHeaderProps, any> {
    public render() {
        return (
            <div className='user'>
                <div className='portrait'>
                    <SvgIcon icon='user' size={2.45}/>
                    <span>{store.authStore.username}</span>
                </div>
                <div className='quit' onClick={() => {this.props.onLogout()}}>
                    <SvgIcon icon='quit' size={2.25}/>
                    <span>Quit</span>
                </div>
            </div>
        )
    }
}
export default UploadHeader
